import { takeEvery } from 'redux-saga/effects'
import { LOCATION_CHANGE } from 'connected-react-router'
import get from 'lodash/get'

import { getManifestFromServer } from 'store/request'
import { getHashCurrentBundle } from 'helpers/common'

export function* handleLocationChange() {
  if (process.env.WEBPACK_FILE !== 'local') {
    try {
      const hashFromBundle = getHashCurrentBundle()
      const manifest = yield getManifestFromServer()
      const hashFromManifest = get(manifest, ['data', 'app.js']).match(/(\d+\w+).js$/)[1]
      console.log('__hashes__', { hashFromBundle, hashFromManifest })
      if (hashFromManifest && hashFromManifest !== hashFromBundle) {
        location.reload(true)
      }
    } catch (e) {
      console.log("Dynamic update bundle doesn't work", { e })
    }
  }
}

export default function* locationChangeSaga() {
  yield takeEvery(LOCATION_CHANGE, handleLocationChange)
}
